"use client";

import { useEffect } from "react";
import { useTranslations } from "next-intl";

import { reportError } from "../../lib/telemetry";

export default function Error({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  const t = useTranslations("common");
  useEffect(() => {
    reportError({
      message: error.message,
      stack: error.stack,
      severity: "route",
    });
  }, [error]);

  return (
    <div className="cgErrorFallback">
      <h2>{t("errorTitle")}</h2>
      <p>{error.message || t("errorUnknown")}</p>
      <button className="cgBtn cgBtnPrimary" onClick={reset}>
        {t("retry")}
      </button>
    </div>
  );
}
